<template>
  <div class="py-4 px-4 flex justify-end sm:px-6">
    <button v-for="(button, index) in buttons" :key="index"
      v-on:click="checkConfirmation(button)"
      :class="`${setColor(button)} mx-2 border rounded-md shadow-sm py-2 px-4 inline-flex justify-center 2xl:text-sm sm:text-xl font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-light-blue-500 disabled:opacity-50`"
      :disabled="checkDisabledButton(button)">
      {{button.label}}
    </button>
    <confirmationmodal v-if="confirmationmodal" :msg="msgModal" :button="selectedButton"/>
  </div>
</template>
<script>

import ConfirmationButtonModal from '@/components/ConfirmationButtonModal'

export default {
  name: 'form-button',
  components: {
    confirmationmodal: ConfirmationButtonModal
  },
  props: {
    disabled: {
      type: Boolean,
      required: true
    },
    isSubmiting: {
      type: Boolean,
      required: true
    }
  },
  mounted(){
    this.getButtons()
    this.watchStore()
  },
  data() {
    return {
      buttonsSubmitings:{},
      typeButtons: ['submitForm', 'confirmSubmit'],
      buttons: [],
      colors: {
        'blue': 'bg-light-blue-700 border-transparent text-white hover:bg-light-blue-800 focus:ring-light-blue-500',
        'red': 'bg-red-500 border-transparent text-white hover:bg-red-600 focus:ring-red-300',
        'white': 'border-gray-300 text-gray-700 hover:bg-gray-50 bg-white'
      },
      selectedButton: {},
      confirmationmodal: false,
      msgModal: ""
    }
  },
  methods: {
    watchStore(){
      this.$store.watch(
        () => this.$store.getters.data['selectedOrder'],
        () => this.getButtons()
      )
    },
    checkDisabledButton({action}){
      const typeDisabled = ['submitForm', 'confirmSubmit']
      const typeIsSubmiting = [...typeDisabled, 'downloadFile', 'runInApi']

      if (typeIsSubmiting.includes(action)){
        if (typeDisabled.includes(action)){
          return this.disabled
        }
        return this.isSubmiting
      }
      return false

    },
    async getButtons(){
      let config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'JWT ' + this.$store.getters.auth.token
        },
        params: {
          method: `footer`,
          ...this.params,
          blueprint: this.$route.params.blueprint,
          record: this.$route.params.record,
          query: this.$route.query,
          selectedOrder: this.$store.getters.data['selectedOrder'] || ''
        }
      }
      const response = await this.$http.get(`/flow/custom/formbuttons`, config)
      this.buttons = response.data
    },
    setColor(button){
      if (button.options_render === 'undefined'){
        return this.colors.white
      }
      if (button.options_render.color === 'undefined' || button.options_render.color === ''){
        return this.colors.white
      }
      return this.colors[button.options_render.color]
    },
    submitButton(button){    
      this.$parent[button.action](button)
    },

    checkConfirmation(button){
      if(button.options_button !== undefined && button.options_button.confirmation === true ){
        this.confirmationmodal = true
        console.log(button.options_render.confirmation_msg)
        this.msgModal = button.options_button.confirmation_msg === undefined ? "":button.options_button.confirmation_msg

        this.selectedButton = button
      }
      else{
        this.submitButton(button)
      }
    }
  }
}
</script>